import './kowTitle.scss'

interface KowTitleProps {
  type?: 'light' | 'dark'
  text: string
}
export default function KowTitle(props: KowTitleProps) {
  const { type, text } = Object.assign<Partial<KowTitleProps>, KowTitleProps>(
    { type: 'light' },
    props
  )

  return (
    <div className={`kow-title kow-title--${type}`}>
      <span>{text}</span>
    </div>
  )
}
